import React from 'react';
import ReactExport from 'react-data-export';
import { Button, Icon, Popup } from 'semantic-ui-react';
import printReportAsPdf from './reportPdfPrint';
import './ReportExcelFile.css';

const NativeExcelFile = ReactExport.ExcelFile;
const exportButtonsStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '6px',
    width: '100%',
    maxWidth: '210px',
    marginLeft: 'auto'
};
const pdfFileName = title => `${(title || 'izvjestaj').replace(/[\\/:*?"<>|]/g, '-')}.pdf`;

const cellValue = cell => {
    if (cell === null || cell === undefined) return '';
    if (typeof cell === 'object' && Object.prototype.hasOwnProperty.call(cell, 'value')) {
        return cell.value === null || cell.value === undefined ? '' : cell.value;
    }
    return cell;
};

const reportDataFromChildren = (children) => {
    const sheet = React.Children.toArray(children)[0];
    if (!sheet || !sheet.props) return { columns: [], rows: [] };

    if (sheet.props.dataSet) {
        const tableDataSet = sheet.props.dataSet.find(dataSet => dataSet.columns && dataSet.data);
        if (!tableDataSet) return { columns: [], rows: [] };

        const columns = tableDataSet.columns.map((column, index) => ({
            label: column.title || column.value || `Kolona ${index + 1}`,
            value: `column${index}`,
        }));
        const rows = tableDataSet.data.map(row => row.reduce((result, cell, index) => ({
            ...result,
            [`column${index}`]: cellValue(cell),
        }), {}));
        return { columns, rows };
    }

    if (sheet.props.data) {
        const excelColumns = React.Children.toArray(sheet.props.children);
        const columns = excelColumns.map((column, index) => ({
            label: column.props.label || `Kolona ${index + 1}`,
            value: `column${index}`,
        }));
        const rows = sheet.props.data.map((item, rowIndex) => excelColumns.reduce((result, column, index) => {
            const value = typeof column.props.value === 'function'
                ? column.props.value(item, rowIndex) : item[column.props.value];
            return { ...result, [`column${index}`]: cellValue(value) };
        }, {}));
        return { columns, rows };
    }

    return { columns: [], rows: [] };
};

const selectedFilters = (button) => {
    const report = button && button.closest('.student-reports');
    if (!report) return [];

    const filters = [];
    report.querySelectorAll('.field').forEach((field) => {
        const labelElement = field.querySelector(':scope > label');
        const label = labelElement && labelElement.textContent.trim();
        if (!label) return;

        const dropdown = field.querySelector('.ui.dropdown');
        const checkbox = field.querySelector('.ui.checkbox input');
        const input = field.querySelector('input:not([type="hidden"]):not([type="checkbox"])');
        let value = '';
        if (dropdown) {
            const textElement = dropdown.querySelector('.text');
            value = textElement ? textElement.textContent.trim() : '';
            if (dropdown.classList.contains('default')) value = '';
        } else if (checkbox) {
            value = checkbox.checked ? 'Da' : 'Ne';
        } else if (input) {
            ({ value } = input);
        }
        if (value && !filters.some(filter => filter.label === label && filter.value === value)) {
            filters.push({ label, value });
        }
    });
    return filters;
};

const ReportExcelFile = ({
    filename, children, element, ...excelProps
}) => {
    const exportPdf = async (event) => {
        const { columns, rows } = reportDataFromChildren(children);
        if (!columns.length || !rows.length) return;
        const button = event.currentTarget;
        await printReportAsPdf({
            title: filename || 'Izvještaj',
            filters: selectedFilters(button),
            columns,
            rows,
            fileName: pdfFileName(filename),
            titleColor: 'black',
        });
    };

    const pdfButton = (
        <Popup
            trigger={<Button
                animated="vertical"
                basic
                color="red"
                fluid
                onClick={exportPdf}
                style={{ textAlign: 'center' }}
            >
                <Button.Content hidden><Icon name="download" /></Button.Content>
                <Button.Content visible>PDF</Button.Content>
            </Button>}
            content="Preuzmi PDF"
            hideOnScroll
            position="top center"
        />
    );

    return (
        <div className="report-export-buttons" style={exportButtonsStyle}>
            <NativeExcelFile filename={filename} element={element} {...excelProps}>{children}</NativeExcelFile>
            {pdfButton}
        </div>
    );
};

export default ReportExcelFile;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/ReportExcelFile.js